import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/sessoes/recorrencias')({
  component: () => <Outlet />,
});
